// extracted by mini-css-extract-plugin
export default {"variableNameWrapper":"PUGcQTDcQOKcIs53Sgf0","variableNameIcon":"bls_NaAmRdzJ6GNuQpJD","variableName":"w4b8TXEHFfVNnkTjUCDc"};